<template>
	<div id="test">
		<div class="section">
			<div class="library-info">
				<h2 class="section-title">Movimento & Performance</h2>
				<img src="@/assets/embodimetria_nosfondo.png" style="display:block; max-width:400px; margin: 0 auto;" align="center">
			</div>
		</div>
		<div class="container-desktop pad-l">
			<h2 style="font-size:2em; text-align: left; margin-top:-0.5em;" id="intro">Sei Gorilla o Gazzella? Le ruote del tuo corpo funzionano in modo efficiente?</h2>
			<div class="p-relative">
					<p style="font-size:1.3em;" class="testotest">
						<img src="@/assets/piramide-02.png" style="max-width:400px;" align="right">
						EXIMUS PERFORMANCE è licenziataria esclusiva nel territorio dei <span style="color: #ffe010;"><b>test EMBODIMETRIA®</b></span>, 
						test scientificamente validati dopo centinaia di studi e brevettati da una società italiana.<br> 
						Grazie a questi test  potrai scoprire se i tuoi arti lavorano in maniera fluida ed efficiente e 
						se ti muovi nello spazio in maniera corretta senza scompensi e alterazioni.<br><br>
						<b>I test che proponiamo sono due:<span style="color: #ffe010;"> PMT® e NFSC®.</span></b></p>
			</div>
		</div>
		<br><br><br><br><br><br><br>
		<div class="container-desktop pad-l">
			<h2 style="font-size:2em; text-align: left; margin-top:-0.5em;" id="protocolli">PMT® e NFSC®</h2>
			<div class="p-relative">
					<p style="font-size:1.3em;" class="testotest">Il test <span style="color: #ffe010;"><b>PMT®, Pattern Movement Test</b></span>, è il protocollo di misurazione dei pattern di movimento 
						volontario, nei domini del tempo, rilevandone sia le capacità a livello di “recupero” che 
						di “codifica” da parte della memoria di lavoro.<br><br>
						<img src="@/assets/embo1.jpg" style="max-height:400px;" align="right">
						Step 1: immagina il corpo umano come una macchina e che i 4 arti siano le 4 ruote: 
						la macchina viaggerebbe in maniera efficace se una di queste ruote fosse sgonfia o disallineata? 
						Credo proprio di no, la stessa cosa vale per il tuo corpo.<br><br>
						<img src="@/assets/embo2.jpg" style="max-height:400px;" align="left">
						Se un arto non si muove in modo corretto creerà una serie di compensi che potrebbero portare 
						problemi in tutto il corpo con conseguenti dolori cronici e infortuni anche in zone lontane 
						dall’arto interessato come mal di schiena o instabilità.<br><br>

						Grazie a questo test possiamo individuare quale articolazione presenta alterazioni e in che 
						modo non funziona come dovrebbe. Dopo la valutazione si possono individuare esercizi specifici 
						con cui correggere e migliorare questa situazione, un pò come fare la convergenza delle ruote 
						alla macchina.<br><br>

						Step 2: ora che che la macchina ha tutte le ruote in ordine devo vedere come si muove nello 
						spazio, se questo movimento è efficiente, economico e non porta problemi a lungo termine.<br><br>
						Per questo motivo nasce <span style="color: #ffe010;"><b>NFSC®, Neurofascial Strength & 
						Conditioning</b></span>, il test della capacità fenotipica di espressione della performance.<br><br>
						<img src="@/assets/embo5.jpg" style="max-height:400px;" align="right">

						Il test individua i percorsi biomeccanici di rilascio energetico della persona 
						(che tu sia un'atleta professionista, amatoriale o semplicemente una persona che vuole 
						migliorare il proprio movimento) segnalando - in continuità con PMT - eventuali 
						relazioni di interferenza dei pattern di Movimento con la realizzazione della Performance.<br><br>
						<img src="@/assets/embo6.jpg" style="max-height:400px;" align="left">

						Con  questo test capirai se sei più <span style="color: #ffe010;"><b>“gazzella”</b></span> ovvero se i tuoi movimenti sono principalmente 
						dati dalle strutture fasciali o se sei più <span style="color: #ffe010;"><b>“gorilla”</b></span> e i tuoi movimenti richiedono maggiormente 
						l’uso dei muscoli.<br>
						Inoltre in base al risultato della valutazione andrà impostato l’allenamento con esercizi 
						regolativi e metodiche specifiche, come l’utilizzo o meno delle scarpe o il tipo di 
						pavimento migliore dove allenarsi.<br><br>
						(Tutti i test possono essere fatti praticamente a chiunque e non richiedono in totale più di 30/45 minuti).</p>
			</div>
		</div>
		<br><br><br><br><br><br><br>
		<div class="container-desktop pad-l">
			<h2 style="font-size:2em; text-align: left; margin-top:-0.5em;" id="intro">Una volta che ho i risultati cosa me ne faccio?</h2>
			<div class="p-relative">
					<p style="font-size:1.3em;" class="testotest">
						<img src="@/assets/App.jpg" style="max-height:400px;" align="right">
						Qui arriva la vera rivoluzione di Embodimetria®! Una volta che avrai visto e analizzato i 
						risultati col tuo bodyworker (coach esperto in movimento umano) verrai registrato 
						sul framework operativo e sulla web APP di Embodimetria® nella quale avrai la tua area riservata, e 
						dove riceverai immediatamente dopo il test i risultati e dove <span style="color: #ffe010;"><b>ti verranno assegnati esercizi 
						correttivi, di respirazione e di Bottom Up personalizzati</b></span> per migliorare subito i tuoi risultati.

						Tramite la web APP avrai accesso alla tua scheda personalizzata, <span style="color: #ffe010;"><b>con video e spiegazione 
						dettagliata di ogni esercizio</b></span> per permetterti di farli direttamente da casa o dove preferisci!<br><br> 

						La maggior parte degli esercizi possono essere fatti ovunque e possono essere integrati nel 
						tuo programma di allenamento attuale senza modificarlo o comprometterlo ma dandoti una 
						marcia in più per fare il salto di qualità!<br><br><br><br><br><br><br><br></p>
			</div>
		</div>
		<div class="container-desktop pad-l">
				<h2 class="section-title">Prenota ora il tuo TEST!</h2>

				<div class="grid">
					<div class="contact-form">
						<form class="pad-l" @submit.prevent="submitTrial">
							<div class="title">Prenota ora il tuo TEST!</div>

							<div class="input-grid">
								<div class="form-input">
									<label>Nome</label>
									<input type="text" v-model="formData.firstName" name="first_name" placeholder="Nome" id="nomeprova" required/>
								</div>

								<div class="form-input">
									<label>Cognome</label>
									<input type="text" v-model="formData.lastName" name="last_name" placeholder="Cognome" required/>
								</div>

								<div class="form-input">
									<label>Email</label>
									<input type="email" v-model="formData.email" name="email" placeholder="Email" required/>
								</div>

								<div class="form-input">
									<label>Cellulare</label>
									<input type="number" v-model="formData.phone" name="phone" placeholder="Cellulare" required/>
								</div>

								<div class="form-input">
									<label>Quale servizio vuoi provare?</label>
										<select v-model="formData.service">
											<option value="TEST">Test Movimento e Performance</option>
											<option value="PT">Personal Training Singolo</option>
											<option value="COPPIA">Personal Training di Coppia</option>
											<option value="CLASS">Small Class</option>
										</select>
								</div>

								<div class="form-input">
									<label>Messaggio (opzionale)</label>
									<textarea rows="5" v-model="formData.message" name="message" placeholder="..."></textarea>
								</div>

								<div class="form-input">
									<label>Data</label>
									<input type="datetime-local" v-model="formData.when" name="when" required/>
								</div>

								<div class="submit">
									<button id="bottoneprova">PRENOTA</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
	</div>

</template>
<script>
import VideoCard from '@/components/library/VideoCard'
import Card from '@/components/home/Cardshop'
import About from '@/components/home/About'
import api from '@/api'

export default {
	name: 'shop',

	components: {
		VideoCard,
		Card,
		About
	},

	data() {

		return {
			/// Authenticated user
			bShowBlogNav: false,
			formData: {
				firstName: '',
				lastName: '',
				email: '',
				phone: '',
				service: 'TEST',
				message: '',
				when: ''
			}
		}
	},

	created(){
     },

	computed: {
		/**
		 * 
		 */
	},

	methods: {
		/**
		 * Send trial request
		 */
		async submitTrial() {
			
			try
			{
				await api.make('POST', /* endpoint */'/public/trial', /* data */{
					first_name: this.formData.firstName,
					last_name: this.formData.lastName,
					email: this.formData.email,
					phone: this.formData.phone,
					service: this.formData.service,
					message: this.formData.message,
					when: this.formData.when
				}, /* bJson */true)

				/*notif.done('Grazie! La tua richiesta è stata inoltrata')*/
				this.$router.push('thankyou')
			}
			catch (e)
			{
				/*console.error('console error')
				notif.error('notif error')*/

  				/*document.getElementById("messaggio").style.display = "block";*/

				/*this.$router.push('thankyou')*/

			}
		}
	},

	mounted() {

		window.scrollTo(0, 0)
	},

}

</script>

<style lang="stylus" scoped>

.testotest
	text-align justify

	img
		margin 1em

		@media (max-width: unit(767, px))
			float none
			display block
			margin 1em auto

.bar
	display grid
	grid-template-columns repeat(3, 1fr)
	grid-gap 1em

	padding 1em

	@media (max-width: unit(767, px))
		grid-template-columns auto

.bar2
	display grid
	grid-template-columns repeat(2, 1fr)
	grid-gap 1em

	padding 1em

	@media (max-width: unit(767, px))
		grid-template-columns auto

.filtro
	width 100%
	background #101418
	height 3em
	margin-bottom 3em

	@media (max-width: unit(767, px))
		height 100%
		padding-bottom 0.7em

.catcont
	width 520px
	margin 0 auto
	position relative
	display flex
	padding-top 0.6em

	@media (max-width: unit(767, px))
		width 100%
		display grid

.menu-button
			height 100%
			margin 0 auto
			display none 

			@media (min-width: unit(768, px))
				display none

			>button
				height 100%

				display flex
				align-items center

				border none

				background-color transparent
				color #dcdcdc

				font-size 2em

				&:focus
					outline none
				&:hover
					background-color mix(darkish, dark)

.mobileblog
	display none

	&.show
		display none

.categoria
	text-transform uppercase
	font-size 1.1em
	font-weight bold
	margin 0 auto

	@media (max-width: unit(767, px))
		color red	

.link
	text-decoration none 
	color #dcdcdc
	transition 0.2s ease

.link:hover
	color #ffe010


.up
	position fixed
	bottom 0
	left 0
	margin-left 1em
	margin-bottom 1em
	width 2.5em
	height 2.5em
	border-radius 2.5em
	background #ffe010
	z-index 9999

.progselect
	max-width 570px
	margin 0 auto
	text-align center

	.progworkout
		max-width 490px
		margin 0 auto
		p
			text-align left
			font-size 1.2 em
			margin-left 0.7em

.divprogramma
	display grid
	grid-template-columns repeat(3, 1fr)
	grid-gap 1em

	@media (max-width: unit(560, px))
		grid-template-columns auto

.programma
	padding 0.4em 0.6em
	border none
	border-bottom 2px solid transparent
	box-sizing border-box
	background-color darkish
	color light
	font-size 1.2em

.divprova
	max-width 100%
	padding 2em
	text-align center

.provagratuita
	max-width 500px

	padding 0.6em
	border none

	background-color primary
	color dark

	font-family fontSans
	font-size 1.6em

	cursor pointer

	transition 0.2s ease

	&:focus
		outline none

.presdesc
	list-style-type none

	li:before
		content: "\2022";  /* Add content: \2022 is the CSS Code/unicode for a bullet */
		color: #ffe010; /* Change the color */
		font-weight: bold; /* If you want it to be bold */
		display: inline-block; /* Needed to add space between the bullet and the text */
		width: 1em; /* Also needed for space (tweak if needed) */
		margin-left: -1em; /* Also needed for space (tweak if needed) */

.divpres
	text-align center

	img
		display block
		margin 0 auto

.divbox
	display grid
	grid-template-columns auto
	grid-gap 1em

	@media (max-width: unit(767, px))
		grid-template-columns auto
	
	ul
		text-transform uppercase
		font-weight bold

.divul
	text-align left
	margin 0 auto

.grid
	display grid
	grid-template-columns 3fr 2fr

	@media (max-width: unit(media-phone-max, px))
		display block

	.fixed-ratio
		position relative

		padding-bottom 56%
		box-sizing border-box

		.map
			position absolute
	
	.contact-form
		grid-column 1/5

		margin 1.5em
		padding 2em

		background-color dark

		.title
			font-size 1.2em
		
		.input-grid
			margin-top 1.5em

			.form-input
				margin 0.5em 0

				box-sizing border-box
				
				label
					display block

					margin-bottom 0.4em

					font-size 0.8em

				input
					width 100%

					display block
				
					padding 0.4em 0.6em
					border none
					border-bottom 2px solid transparent
					box-sizing border-box

					background-color darkish
					color light

					font-size 1.2em

					transition 0.2s ease

					&:focus
						outline none
						border-bottom 2px solid primary
				
				select
					padding 0.4em 0.6em
					border none
					border-bottom 2px solid transparent
					box-sizing border-box

					background-color darkish
					color light

					font-size 1.2em
				
				textarea
					width 100%

					display block

					padding 0.4em 0.6em
					border none
					border-bottom 2px solid transparent
					box-sizing border-box

					background-color darkish
					color light

					font-family fontSans
					font-size 1.1em

					transition 0.2s ease

					&:focus
						outline none
						border-bottom 2px solid primary
			
			.submit
				margin-top 4em

				button
					width 100%

					padding 0.6em
					border none

					background-color primary
					color dark

					font-family fontSans
					font-size 1.3em

					cursor pointer

					transition 0.2s ease

					&:focus
						outline none

	.how
		.where
			margin-bottom 1em

			font-size 1.1em

	.contacts
		.mail
		.phone
			color lighten(secondary, 20%)

			text-decoration none

			&:hover
				text-decoration underline

	.socials
		.social-list
			display flex
			align-items center

			margin-top 0.2em
			margin-left 0.2em

			font-size 1.4em

			>a
				padding 0.3em

				color light

				text-decoration none

				transition 0.15s ease

				&:hover
					border-radius 50%

					background-color dark

					&.fa-facebook
						color #30C0F0
					&.fa-instagram
						color #D080D0
</style>
